module.exports = __webpack_public_path__ + "static/media/2025_1_DESKTOP.82db57e4.png";